export const SIGNATURE_TYPES = ['NONE', 'SINGLE', 'COLLECTIVE_TWO', 'COLLECTIVE_MORE'] as const
export type SignatureType = typeof SIGNATURE_TYPES[number]

/** i18n keys for the signature authority of a contact, by enum value. */
export const SIGNATURE_TYPE_LABEL_KEYS: { readonly [K in SignatureType]: string } = {
  NONE: 'contacts.signatureNone',
  SINGLE: 'contacts.signatureSingle',
  COLLECTIVE_TWO: 'contacts.signatureCollectiveTwo',
  COLLECTIVE_MORE: 'contacts.signatureCollectiveMore',
}
